import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { useAppSelector } from "../../../../../application/states/hooks";
import { useMemo } from "react";
import { Box, Divider, Grid, Typography } from '@mui/material';
import { darkenColor } from '../../../../../utils';


ChartJS.register(ArcElement, ChartTooltip, Legend);

export const ProjectReportResume = () => {
  const projectReport = useAppSelector((state) => state.project.projectReport)
  const { resaleConfig } = useAppSelector((state) => state.resaleConfig)

  const MIN_SLICE = 0.5; // porcentagem mínima visual

  const rawData = [
    projectReport?.generalData.usage.exported ?? 0,
    projectReport?.generalData.usage.available ?? 0,
    projectReport?.generalData.usage.lurik ?? 0,
  ];

  const total = rawData.reduce((acc, val) => acc + val, 0);

  let adjustedData = rawData.map((val) => {
    const percent = (val / total) * 100;
    return percent < MIN_SLICE && val > 0 ? (MIN_SLICE / 100) * total : val;
  });

  // Corrigir o total para não distorcer o gráfico
  const adjustedTotal = adjustedData.reduce((acc, val) => acc + val, 0);
  adjustedData = adjustedData.map((val, idx) => {
    // Ajusta proporcionalmente para manter o total igual ao original
    return (val / adjustedTotal) * total;
  });

  const exportedData = useMemo(() => {
    return {
      labels: [
        'Extraídos',
        'Disponíveis',
        `${resaleConfig?.id !== '' ? `${resaleConfig?.name}` : 'Lurik'}`
      ],
      datasets: [
        {
          label: 'registros',
          data: adjustedData,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            `${resaleConfig?.id !== '' ? `${darkenColor(resaleConfig!.theme.colors.primary.main, 0.2)}` : 'rgb(114, 57, 137, 0.2)'}`
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            `${resaleConfig?.id !== '' ? `${resaleConfig?.theme.colors.primary.main}` : '#723989'}`
          ],
          borderWidth: 1,
        },
      ],
    }
  }, [adjustedData, resaleConfig])

  // Opções do gráfico para mostrar o valor real no tooltip
  const chartOptions = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context: any) {
            // Pega o valor real do backend (sem o deduplicado)
            const realValues = [
              projectReport?.generalData.usage.exported ?? 0,
              projectReport?.generalData.usage.available ?? 0,
              projectReport?.generalData.usage.lurik ?? 0,
            ];
            const label = context.label || '';
            const value = realValues[context.dataIndex];
            return `${label}: ${value.toLocaleString('pt-BR')}`;
          }
        }
      }
    }
  };

  return (
    <>
      <Box p={3} style={{
        width: '100%'
      }}>
        <Grid container spacing={2}>

          <Grid item xs={12}>
            <Typography align="center" fontWeight="bold" variant="h5" color="primary">
            Quantitativo
            </Typography>
            <Box p={2}>
              <Grid container justifyContent="center">
                <Grid item>
                  <Pie color="white" data={exportedData} options={chartOptions} />
                </Grid>
              </Grid>
            </Box>
            <Grid container justifyContent={"center"} spacing={2}>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span
                    style={{
                      color: resaleConfig?.id !== '' ? resaleConfig?.theme.colors.primary.main : '#723989'
                    }}
                  >
                    {resaleConfig?.id !== '' ? `${resaleConfig?.name}: ` : 'Lurik: '}
                  </span>
                  {projectReport?.generalData.usage.lurik.toLocaleString('pt-BR')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography align="center" fontWeight="bold">
                  <span style={{
                    color: 'rgba(255, 99, 132, 1)',
                  }}>Extraídos:</span>  {projectReport?.generalData.usage.exported.toLocaleString('pt-BR')}
                </Typography>
              </Grid>

            </Grid>

          </Grid>
          <Grid item xs={12}>
            <Divider variant="middle" />
          </Grid>

          <Grid item xs={12}>
            <Typography align="center" fontWeight="bold">
              <span style={{
                color: 'rgba(54, 162, 235, 1)'
              }}>Disponíveis:</span>  {projectReport?.generalData.usage.available.toLocaleString('pt-BR')}
            </Typography>
          </Grid>

        </Grid>
      </Box>
    </>
  )
}